// losePanel.js
var LosePanel = pc.createScript('losePanel');

// initialize code called once per entity
LosePanel.prototype.initialize = function() {

    LosePanel.instance = this; 
    var self = this;

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame){
        self.entity.children[3].element.text = 'SCORE: ' + 0;
    }
    else {
        self.entity.children[3].element.text = 'SCORE: ' + PlayerManager.instance.userData.score.toString();
    }

    this.entity.children[1].button.once('click', function (event) {
        rewardedType = adsType.InterstitialFinishFailGame;
        levelEndAd = true;
        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk.showAd()
                .then(response => {
                })
                .catch(error => {
                    console.log("Error Rewarded ADS");
                    LosePanel.instance.loseGameNextButton();
                });
        }

        // WinAndLoseUi.instance.showPanelBackground(false);
        // if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "LevelEndContinueButton:Click", 1);}
        // SoundManager.instance.stopSound('LoseSound');
        // roomObjectList =[];
        // loadScene(`Menu`, { hierarchy: true, settings: true });
    });

};

LosePanel.prototype.loseGameNextButton = function() {
        WinAndLoseUi.instance.showPanelBackground(false);
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "LevelEndContinueButton:Click", 1);}
        SoundManager.instance.stopSound('LoseSound');
        roomObjectList =[];
        loadScene(`Menu`, { hierarchy: true, settings: true });
};


